<template>
  <div :style="computedStyle">
    <el-select
      v-model="limit"
      size="medium"
      :title="$i18n.t('limitation_selector')"
    >
      <el-option v-for="option in [10, 25, 50]" :value="option" :label="limitOption(option)" :key="option">
        {{ limitOption(option) }}
      </el-option>
    </el-select>
  </div>
</template>

<script>
import pagination from '../../../../utils/mixin-pagination'
import localStore from '../../../../utils/mixin-local-store'

export default {
  name: 'Limitation',
  mixins: [pagination, localStore],
  data() {
    return {
      parent: null,
    }
  },
  computed: {
    computedStyle() {
      return `height: ${this.height}px;align-items: center;display: flex;`
    },
    height() {
      return this.parent && this.parent.getBoundingClientRect().height
    },
    namespace() {
      return this.$get('moduleName')
    },
    pageSize() {
      return this.$get('pageSize')
    },
    panelId() {
      return this.$get('panelId')
    },
  },
  mounted() {
    this.createLocalStore()
    this.parent = document.querySelector('.templated-list-hamburger')
  }
}
</script>